var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/VersionButton/VersionInfoTooltip.tsx";
import { Fade } from '@mui/material';
import React from 'react';
import { Tooltip, CloudConfirm } from '@gmini/ui-kit';
import { ImportErrorTooltip } from "../../../../components";
import { formatDateTime } from "../../../Migration/UpdateDialog";
import { importErrorTooltipCodeDescriptionMap, importErrorTooltipCodeMap } from "../../importErrorMessageMap";
import { Title, Description, TitleWrapper, TooltipWrapper } from "./VersionInfoTooltip.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VersionInfoTooltip = /*#__PURE__*/React.memo(function (_ref) {
  var author = _ref.author,
      uploadDate = _ref.uploadDate,
      versionName = _ref.versionName,
      children = _ref.children,
      status = _ref.status,
      errorCode = _ref.errorCode;
  return status === 'ImportError' && errorCode ? /*#__PURE__*/_jsx(ImportErrorTooltip, {
    version: versionName,
    errorText: importErrorTooltipCodeMap[errorCode],
    description: importErrorTooltipCodeDescriptionMap[errorCode],
    children: children
  }) : /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom-start",
    arrow: true,
    enterDelay: 200,
    enterNextDelay: 200,
    TransitionComponent: Fade,
    title: /*#__PURE__*/_jsxs(TooltipWrapper, {
      children: [/*#__PURE__*/_jsxs(TitleWrapper, {
        children: [/*#__PURE__*/_jsx(CloudConfirm, {
          color: "#fff"
        }), /*#__PURE__*/_jsxs(Title, {
          children: [tooltipTitleByStatus(status), " ", versionName, ' ']
        })]
      }), /*#__PURE__*/_jsxs(Description, {
        children: [author ? "".concat(author, ",") : '', " ", formatDateTime(uploadDate)]
      })]
    }),
    children: children
  });
});
VersionInfoTooltip.displayName = 'VersionInfoTooltip';

function tooltipTitleByStatus(status) {
  switch (status) {
    case 'NotImported':
      return 'Доступна, не загружена версия';

    case 'ImportInProgress':
      return 'Загрузка версии';

    case 'ImportCompleted':
      return 'Загружена версия';

    case 'ImportError':
      return 'Ошибка загрузки версии';
  }
}